import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['user'])
}



// WEBPACK FOOTER //
// ./src/app/tenant/files/resources/computed.js